import React from "react";
import Acesso from "../acesso-rapido/AcessoRapido";
import { useAuth } from "../../hooks/useAuth";

import "../../components/menu-lateral/Style.css";
import { FiUser } from "react-icons/fi";

export default function () {
  const { user, account } = useAuth()

  const agency = account?.bankBranch || '0000'
  const accountNumber = account?.bankAccount || '0000000000'
  const accountDigit = account?.bankAccountDigit || '0'
  const accountBank = account?.bank || '000'

  const getAvatar = () => {
    const isMainUser = user?.isMainAccess;

    if (isMainUser && user?.avatar) {
      return <img src={user?.avatar?.url} alt="" />
    } 
    if (!isMainUser && user?.companyUser?.avatar) {
      return <img src={user?.companyUser?.avatar?.url} alt="" />;
    }

    return <FiUser size={20} />;
  };

  const getName = () => {
    if (user?.companyUser?.name) {
      return user?.companyUser?.name?.split(' ')[0];
    }
    return user?.name?.split(' ')[0];
  };

  return (
    <div className={`menu`}>
        <div className="d-flex header-menu">
          <div className="perfil">
            <div className="client-icon" >
              {getAvatar()}
            </div>
          </div>
          <div className="menu-name" title={user?.companyUser?.name || user?.name}>
            <div>Olá, {getName()} </div>
          </div>
        </div>

        <div className="conta">
            <div className="col-md-3">
              <p style={{'fontSize': '12px','marginBottom': '-5px'}}>Banco</p>
              <p style={{'fontSize': '14px'}}>{accountBank}</p>
            </div>
            <div className="col-md-3">
              <p style={{'fontSize': '12px','marginBottom': '-5px'}}>Ag</p>
              <p style={{'fontSize': '14px'}}>{agency}</p>
            </div>
            <div className="col-md-6">
              <p style={{'fontSize': '12px','marginBottom': '-5px'}}>Conta</p>
              <p style={{'fontSize': '14px'}}>{accountNumber}-{accountDigit}</p>

            </div>
        </div>
        <Acesso/>
    </div>
  );
}
